<template>

    <q-list bordered padding class="rounded-borders">

        <q-item class="mediumdense" clickable v-ripple @click="toggleItem('inbound')">
            <q-item-section avatar>
                <q-icon :color="selected_items.some(a => a === 'inbound') ? 'primary' : undefined" :name="selected_items.some(a => a === 'inbound') ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'" />
            </q-item-section>

            <q-item-section>
                {{ Translate('Inbound') }}
            </q-item-section>
        </q-item>

        <q-item class="mediumdense" clickable v-ripple @click="toggleItem('outbound')">
            <q-item-section avatar>
                <q-icon :color="selected_items.some(a => a === 'outbound') ? 'primary' : undefined" :name="selected_items.some(a => a === 'outbound') ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'" />
            </q-item-section>

            <q-item-section>
                {{ Translate('Outbound') }}
            </q-item-section>
        </q-item>

    </q-list>

</template>

<script>
    import { QList, QItem, QItemSection, QIcon } from 'quasar';
    import methods from '@/Shared/methods';

    export default {
        components: { QList, QItem, QItemSection, QIcon },
        // Required in Vue 3 so parent @change is the component emit, not a native
        // DOM listener — otherwise blur/click on the grid delivers an Event and
        // localUpdateFilterValue treats Event.type as filter criteria (CCDEV-18136).
        emits: ['change'],
        data: function () {
            return {
                selected_items: [],
            }
        },
        props: {
            item: Object,
            value: null,
        },
        created() {
            if (this.value && this.value.values)
                this.selected_items = this.value.values;
        },
        watch: {
            selected_items: function (newv) {
                if (newv.length < 1)
                    this.$emit('change', {});
                else
                    this.$emit('change', {
                        filterType: "set",
                        values: newv
                    });
            },
            value: {
                handler(newValue) {
                       this.syncFromProps(newValue);
                },
                deep: true,
                immediate: true 
            }
        },
        methods: {
            ...methods,
            toggleItem(v) {
                const i = this.selected_items.indexOf(v);
                const next = [...this.selected_items];
                if (i >= 0) next.splice(i, 1);
                else next.push(v);
                this.selected_items = next;
            },
             syncFromProps(value) {
                if (!value || Object.keys(value).length === 0 || value.cleared == 1) {
                    if (this.selected_items.length > 0)
                    {
                      this.selected_items = [];
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }
</style>
